import React from 'react';

// Create a React context to share the editor reference across components
const EditorContext = React.createContext(null);

export default EditorContext;